export const VIEWTYPE_SELECT = 1;
export const VIEWTYPE_SELECT_EDIT = 2;
export const VIEWTYPE_CHECKBOX = 3;
export const VIEWTYPE_CHECKBOX_NUM = 4;
export const VIEWTYPE_TEXT = 5;
export const VIEWTYPE_URL = 11;    
export const VIEWTYPE_DATE = 12;
export const VIEWTYPE_TIME = 13;
export const VIEWTYPE_DATETIME = 14;
export const VIEWTYPE_NUMERIC = 15;
export const VIEWTYPE_NUMERIC_POSITIVE = 16;